import { Button } from 'devextreme-react';
import styled from 'styled-components';

export const LogOutButton = styled(Button)`
  font-weight: 500;
`;
